import { JournalId } from 'types';
import { AutomaticCheckJournalId } from 'types/automaticCheckJournal';

export const AUTOMATIC_CHECK_JOURNAL_LIST = (journalId: JournalId) =>
    `/api/v2/journals/checks/${journalId}`;

export const AUTOMATIC_CHECK_JOURNAL_DETAILS = (automaticCheckId: string) =>
    `/api/v2/journals/checks/details/${automaticCheckId}`;

export const ADD_AUTOMATIC_CHECK_JOURNAL = () => `/api/v2/journals/checks`;

export const AUTOMATIC_CHECK_JOURNAL_SEND_NOTIFICATION = (
    automaticCheckJournalId: AutomaticCheckJournalId,
) => `/api/v2/journals/checks/${automaticCheckJournalId}/notifications`;
